import { TaskAlt } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import {
  MenuResult,
  TransformMenuResult,
} from 'api/ordering-service/ordering-service.types';
import { useSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const useMenusToast = (
  status: 'IN_PROGRESS' | 'COMPLETED',
  data: MenuResult | TransformMenuResult,
  isError: boolean,
) => {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const infoSnackbarRef = useRef(null);

  useEffect(() => {
    if (status === 'IN_PROGRESS')
      infoSnackbarRef.current = enqueueSnackbar(
        t('MenusDataGrid.column.actions.publish.alertMessage.info', {
          catalogTitle: data?.title,
        }),
        {
          key: 'infoSnackbarKey',
          severity: 'info',
          persist: true,
          preventDuplicate: true,
          AlertProps: {
            icon: <CircularProgress size={20} />,
          },
        },
      );
  }, [data?.title, enqueueSnackbar, status, t]);

  useEffect(() => {
    if (status === 'COMPLETED') {
      closeSnackbar();
      enqueueSnackbar(
        t('MenusDataGrid.column.actions.publish.alertMessage.success', {
          catalogTitle: data?.title,
        }),
        {
          persist: false,
          preventDuplicate: true,
          severity: 'success',
          AlertProps: {
            icon: <TaskAlt fontSize="small" />,
          },
        },
      );
    }
  }, [closeSnackbar, data?.title, enqueueSnackbar, status, t]);

  useEffect(() => {
    if (isError) {
      closeSnackbar('infoSnackbarKey');
    }
  }, [closeSnackbar, isError]);
};

export default useMenusToast;
